import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class PaymentTermsForm extends BaseModel {
  payment_terms = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    payment_terms: 'required'
  };

  attributeHints = {
    payment_terms: i18n.t('Please indicate payment period in number of days')
  };

  attributeLabels = {
    payment_terms: i18n.t('Payment Terms'),
  };
}
